import HeroSection from "./HeroSection";
import { Col, Row } from "react-bootstrap";
import "./InsightsSearchBlock.scss";
import PopularSearches from "./PopularSearches";
import WhyNeedInsights from "./WhyNeedInsights";
import QuoteSection from "./QuoteSection";

const InsightsSearchBlock = () => {
  return (
    <div className="InsightsSearchBlock">
      <Row>
        <Col>
          <HeroSection />
        </Col>
      </Row>
      <Row>
        <Col>
          <PopularSearches />
        </Col>
      </Row>
      <Row>
        <Col>
          <WhyNeedInsights />
        </Col>
      </Row>
      <Row>
        <Col>
          <QuoteSection />
        </Col>
      </Row>
    </div>
  );
};

export default InsightsSearchBlock;
